module.exports = __webpack_public_path__ + "static/media/back-hat.7e50661c.jpeg";